import React from 'react'
import { Box } from 'rebass/styled-components'

const Video = ({ videoSrcURL, videoTitle, height, ...props }) => {
    return (
        <Box sx={{
            backgroundColor: 'white',
            height: '0',
            paddingBottom: '56.25%',
            position: 'relative',
        }}>
            <Box
                height="100%"
                width="100%"
                sx={{
                    left: '0',
                    position: 'absolute',
                }}
            >
                <iframe
                    src={videoSrcURL}
                    title={videoTitle}
                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                    frameBorder="0"
                    webkitallowfullscreen="true"
                    mozallowfullscreen="true"
                    allowFullScreen
                    height="100%"
                    width="100%"
                />
            </Box>
        </Box>
    )
}
export default Video
